/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartContinue").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());
    const variantIDToCompareAtPrice = cartData.variantIDToCompareAtPrice;
    const variantIDToProduct = cartData.variantIDToProduct;
    const variantIDToRecommendedAccessories = cartData.variantIDToRecommendedAccessories;
    const variantIDToRecommendedProducts = cartData.variantIDToRecommendedProducts;

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerCart').setAttribute("data-count", cart.item_count);

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartContinue").classList.add("active");
        document.querySelector(".miniCartRecommended").classList.remove("active");
        document.querySelector("#miniCartHeader").classList.remove("active");
        document.querySelector("#miniCartShipping").classList.remove("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector(".miniCartRecommended").classList.remove("active");
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartShipping").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // update price in footer
    document.querySelector('#miniCartFooterCheckoutPrice').textContent = price(cart.total_price);

    // Free shipping for price threshold
    if (cartSettings.free_shipping_method === "threshold") {
        let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
        if (cart.total_price >= freeShippingThreshold) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You qualify for free shipping.";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = `${price(freeShippingThreshold - cart.total_price)} away from free shipping`;
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // keep track of safes, update the discount if 2+ safes added
    let safeItems = 0;

    // append cart
    cart.items.forEach(function (item) {

        if (item.product_type.toLowerCase() === 'safe') safeItems += +item.quantity;

        // variant HTML
        function variantHTML() {
            const variantProduct = variantIDToProduct[item.id];

            // check for different variants
            if (variantProduct.variants.length <= 1) {
                return "";
            }
            // gather variants for updating cart item
            const variants = [];
            let firstVariant;

            for (let variant of variantProduct.variants) {

                // for color swatch
                const color = variant.title.includes('/')
                    ? variant.title.split('/')[1] : variant.title

                // check if it is the active variant
                if (variant.id === item.id) {
                    firstVariant = `<div class="miniCartBodyItemVariantItem" data-id="${variant.id}">
                        <span class="miniCartBodyItemVariantItemSwatch ${color.trim().toLowerCase().replace(' ', '')}"></span>
                        <span>${variant.title}</span>
                     </div>`;
                } else {
                    variants.push(
                        `<div class="miniCartBodyItemVariantItem" data-id="${variant.id}">
                        <span class="miniCartBodyItemVariantItemSwatch ${color.trim().toLowerCase().replace(' ', '')}"></span>
                        <span>${variant.title}</span>
                     </div>`
                    )
                }
            }

            return `<div class="miniCartBodyItemVariant">
                        ${firstVariant}
                        <div class="miniCartBodyItemVariantInner">
                            <div>
                                ${variants.length > 0 ? variants.join('') : ""}
                            </div>
                        </div>
                        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 0.699951L7 6.29995L0.999999 0.699951" stroke="#B3B3B3" stroke-width="1.3">
                             </path>
                        </svg>
                    </div>`;
        }

        // discount HTML
        function discount() {
            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                return `
                <div class="miniCartBodyItemDiscount" data-price="${item.original_line_price} -- ${item.final_line_price}">
                    <svg aria-hidden="true" focusable="false" class="icon icon-discount color-foreground-" viewBox="0 0 12 12" style="width: 12px; height: 12px;">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
                        </path>
                    </svg>
                    <span>${Math.floor(((item.original_line_price - item.final_line_price) / item.original_line_price) * 100)}% OFF</span>
                </div>`;
            }
            return ``;
        }

        // insert item
        document.querySelector("#miniCartBodyInner").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <a href="${item.url}">
                    <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                    <button class="miniCartBodyItemRemove" title="remove item">Remove</button>
                </a>
                <div>
                    <div class="cartItemTop">
                        <div class="miniCartBodyItemTitle">${item.product_title}</div>
                        <div class="miniCartBodyItemPrice">${price(item.final_line_price)}</div>
                    </div>
                    <div class="cartItemBottom">
                        ${variantHTML()}
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus" title="decrease amount">-</button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus" title="increase amount">+</button>
                        </div>
                    </div>
                    ${discount()}
                </div>
            </div>
        `);

    });

    if (safeItems >= 2) {
        const discountMessage = document.querySelector('#miniCartBodyInner')?.dataset.discountText;
        if (discountMessage !== "") {
            document.querySelectorAll('.miniCartBodyItemDiscount')?.forEach(element => {
                element.querySelector('span').textContent = discountMessage;
            })
        }
    }

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function (e) {
            e.preventDefault();
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart(true);
        }
    });

    // add upsell items for each cart item
    const noRepeats = [];
    const accessoriesAdd = [];
    const productsAdd = [];
    cart.items.forEach((item) => {
        const accessories = variantIDToRecommendedAccessories[item.id];
        const products = variantIDToRecommendedProducts[item.id];

        // add items to groups
        buildItems(accessories, accessoriesAdd, true);
        buildItems(products, productsAdd);

        function buildItems(list, array, accessories = false) {
            for (const key in list) {

                const active = list[key];

                // check if type product in accessories
                if (accessories && active.type === 'Safe') continue;
                // check if repeated upsells
                if (noRepeats.includes(active.id)) continue;
                // check if item is in cart
                let isInCart = cart.items.some(cartItem => cartItem.product_id === active.id);
                if (isInCart) continue;

                function firstVariant() {
                    return `<div class="miniCartBodyItemVariantItem" data-id="${active.variants[0].id}">
                        <span class="miniCartBodyItemVariantItemSwatch ${active.variants[0].title.trim().toLowerCase()}"></span>
                        <span>${active.variants[0].title}</span>
                     </div>`
                }

                function upsellVariants() {
                    if (active.variants.length <= 1) {
                        return ``;
                    }

                    let HTML = ``;
                    for (const variant of active.variants) {
                        let hiddenClass = "";
                        if (variant.id === active.variants[0].id) hiddenClass = "active";

                        HTML += `<div class="miniCartBodyItemVariantItem ${hiddenClass}" data-color="${variant.title.trim()}" 
                                        data-id="${variant.id}">
                        <span class="miniCartBodyItemVariantItemSwatch ${variant.title.trim().toLowerCase()}"></span>
                        <span>${variant.title}</span>
                     </div>`
                    }

                    return HTML;
                }

                array.push(`
            <div class="miniCartRecommendedListItem">
                    <img class="miniCartRecommendedListItemImage"
                        src="${active.variants[0].featured_image?.src || active.featured_image}" alt="${active.variants[0].title}"/>
                    <div class="miniCartRecommendedListItemBody">
                        <div class="miniCartRecommendedListItemBodyTop">
                            <a href="${active.url}">${active.title}</a>
                            <div>${price(active.price)}</div>
                        </div>
                        <div class="miniCartRecommendedListItemBodyBottom">
                            <div class="miniCartRecommendedListItemSelect">
                                ${firstVariant()}
                                <div class="miniCartRecommendedListItemSelectDrop">
                                    <div>
                                        ${upsellVariants()}
                                    </div>
                                </div>
                            </div>
                            <button class="miniCartRecommendedListItemButton" title="add item">Add</button>
                        </div>
                    </div>
                </div>
            `)
                noRepeats.push(active.id);
            }
        }
    })

    // add upsell items if any
    if (accessoriesAdd.length > 0) {
        document.querySelectorAll('.miniCartRecommendedAccessoriesList').forEach(el => el.innerHTML = accessoriesAdd.join(''));
        document.querySelectorAll('.miniCartRecommendedAccessories').forEach(el => el.classList.add('active'));
    } else {
        document.querySelectorAll('.miniCartRecommendedAccessoriesList').forEach(el => el.innerHTML = ``);
        document.querySelectorAll('.miniCartRecommendedAccessories').forEach(el => el.classList.remove('active'));
    }
    if (productsAdd.length > 0) {
        document.querySelectorAll('.miniCartRecommendedProductsList').forEach(el => el.innerHTML = productsAdd.join(''));
        document.querySelectorAll('.miniCartRecommendedProducts').forEach(el => el.classList.add('active'));
    } else {
        document.querySelectorAll('.miniCartRecommendedProductsList').forEach(el => el.innerHTML = ``);
        document.querySelectorAll('.miniCartRecommendedProducts').forEach(el => el.classList.remove('active'));
    }

    // if no upsells, hide whole recommended section
    if (accessoriesAdd.length > 0 || productsAdd.length > 0) {
        document.querySelector('.miniCartRecommended').classList.add('active');
        document.querySelector('.miniCartRecommendedMobile').classList.add('active');
    } else {
        document.querySelector('.miniCartRecommended').classList.remove('active');
        document.querySelector('.miniCartRecommendedMobile').classList.remove('active');
    }

    // add upsell dropdown listeners
    document.querySelectorAll('.miniCartRecommendedListItemSelect')?.forEach(el => {
        el.addEventListener('click', function () {
            this.classList.toggle('active');
        })
    })

    // swap selected upsell variant
    document.querySelectorAll('.miniCartRecommendedListItemSelectDrop .miniCartBodyItemVariantItem')?.forEach(el => {
        el.addEventListener('click', function () {
            // hide/show on dropdown
            this.closest('.miniCartRecommendedListItemSelectDrop')
                .querySelector('.miniCartBodyItemVariantItem.active')?.classList.remove('active');
            this.classList.add('active');
            // update the presented option
            this.closest('.miniCartRecommendedListItemSelect').querySelector('.miniCartBodyItemVariantItem').innerHTML =
                `
                        <span class="miniCartBodyItemVariantItemSwatch ${this.dataset.color.toLowerCase()}"></span>
                        <span>${this.dataset.color}</span>
            `;
        })
    })

    // Add Upsell function
    document.querySelectorAll('.miniCartRecommendedListItemButton').forEach(function (element) {
        element.addEventListener("click", async function () {
            // get variant ID from dropdown selector
            const variantID = this.closest('.miniCartRecommendedListItemBodyBottom')
                    ?.querySelector('.miniCartBodyItemVariantItem.active')?.dataset.id
                || this.previousElementSibling.querySelector('.miniCartBodyItemVariantItem')?.dataset.id;

            if (!variantID) return;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // create form data
            let formData = {
                items: [{
                    quantity: 1,
                    id: variantID,
                }]
            };

            // add product upsell
            await addProduct(formData);

            // remove loading animation
            this.classList.remove("loading");

            await openCart();
        });
    });

    // variant dropdown
    document.querySelectorAll('.miniCartBodyItemVariant')?.forEach(el => {
        el.addEventListener('click', function () {
            this.classList.toggle('active');
        })
    })

    // variant selector
    document.querySelectorAll('.miniCartBodyItemVariantInner .miniCartBodyItemVariantItem')?.forEach(el => {
        el.addEventListener('click', async function () {

            // remove current variant
            await updateCart({
                updates: {[this.closest('.miniCartBodyItem').dataset.key]: 0}
            });

            // add new variant
            await addProduct({items: [{quantity: 1, id: this.dataset.id}]})

            // update active body
            await openCart();

        })
    })
}

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));

document.querySelector('#minCartFooterLink').addEventListener('click', () => {
    window.location.replace('/cart');
})

// check is coming from the cart
// if (document.referrer.includes("/cart")) {
//     openCart();
// }